module.exports = __webpack_public_path__ + "img/vueRouterLogo.987be3a8.png";